import React from 'react'
import { Formik, Form} from 'formik'
import * as Yup from 'yup'
import '../Styles/Login.css'
import { FaFacebook, FaGooglePlusG, FaTwitter } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import FormControl from '../Form/FormControl'



const initialValues = {
    email: '',
    password: ''
}

const verify = values => {
    console.log(values)
}

const validationSchema = Yup.object({
    email: Yup.string().email('Invalid mail Format').required('Required!'),
    password: Yup.string()
            .required('No password provided.') 
                .min(8, 'Password is too short - should be 8 chars minimum.')
                    .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),
})

const Login = () => {


    
    return (
        <div className='login-container'>
           <div className="form">
            <div className="heading">
                    <h2 className="head">
                        Welcome Again
                    </h2>
                    <p className="text">
                        Get answers within minutes and finish your homework faster
                    </p>
                </div>
                <Formik 
                    initialValues={initialValues}
                        validationSchema={validationSchema}
                            onSubmit={verify}>

                    {formik => (
                        <Form>

                                    <FormControl
                                        control='input'
                                            type='email'
                                                label='Email'
                                                    name='email'
                                                    placeholder='Email ...'/>

                                    <FormControl
                                        control='input'
                                            type='password'
                                                label='Password'
                                                    name='password'
                                                    placeholder='Paswword ...'/>

                            <button type='submit' className='submit'>Submit</button>
                        </Form>
                    )}

                </Formik>

                <div className="alternate">
                            <p className="line-break">
                                or
                            </p>

                            <div className="social-tabs">
                                <button className="google social">
                                    <FaGooglePlusG className='icon'/>
                                    <span className="text">
                                        Google
                                    </span>
                                </button>
                                <button className="facebook social">
                                    <FaFacebook className='icon'/>
                                    <span className="text">
                                        Facebook
                                    </span>
                                </button>
                                <button className="twitter social">
                                    <FaTwitter className='icon'/>
                                    <span className="text">
                                        Twitter
                                    </span>
                                </button>
                            </div>
                </div>

                    <p>
                        Don't have an Account?  
                        <Link to='/SignUp' className='sign-up'>
                             Sign up
                        </Link>
                    </p>
                    
           </div>
        </div>
    )
}

export default Login
